<!-- Applying width and height styles directly to synchronize icon sizing between web/browser/desktop -->
<div class="tw-flex tw-justify-center tw-items-center" [ngStyle]="iconStyle()" aria-hidden="true">
  @if (data$ | async; as data) {
    @if (data.imageEnabled && data.image) {
      <img
        [src]="data.image"
        class="tw-rounded-md"
        alt=""
        decoding="async"
        loading="lazy"
        [ngClass]="{
          'tw-invisible tw-absolute': !imageLoaded(),
          'tw-size-6': !coloredIcon(),
        }"
        [ngStyle]="iconStyle()"
        (load)="imageLoaded.set(true)"
        (error)="imageLoaded.set(false)"
      />
    }
    @if (!data.imageEnabled || !data.image || !imageLoaded()) {
      @if (data.icon?.startsWith("credit-card-icon ")) {
        <div
          class="tw-flex tw-items-center tw-justify-center"
          [ngStyle]="iconStyle()"
        >
          <i
            class="bwi bwi-lg {{ data.icon }}"
            [ngStyle]="{
              width: coloredIcon() ? '36px' : null,
              height: coloredIcon() ? '30px' : null,
            }"
          ></i>
        </div>
      } @else {
        @let p = tile();
        <span class="vk-tile" [attr.data-kind]="p.kind" [ngStyle]="tileStyle()">
          <svg
            viewBox="0 0 24 24"
            [attr.width]="glyphSizePx()"
            [attr.height]="glyphSizePx()"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              [attr.d]="p.body"
              style="fill: var(--picto-body, #fff); stroke: var(--picto-body, #fff)"
              stroke-width="1.2"
            />
            @if (p.soft) {
              <path
                [attr.d]="p.soft"
                style="stroke: var(--picto-body, #fff)"
                stroke-width="1.8"
              />
            }
            @if (p.detail) {
              <path
                [attr.d]="p.detail"
                style="stroke: var(--picto-detail, #3b6cf0)"
                stroke-width="1.6"
              />
            }
          </svg>
        </span>
      }
    }
  }
</div>
